import React, { useEffect, useState } from "react";
import { agentApi } from "../../services/agentApi";

function formatRelative(date) {
  const now = new Date();
  const target = new Date(date);
  const diffDays = Math.floor((target - now) / 86400000);
  if (diffDays === 0) return "Hoje";
  if (diffDays === 1) return "Amanhã";
  if (diffDays > 1 && diffDays < 7) {
    return target.toLocaleDateString("pt-BR", { weekday: "long" });
  }
  return target.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}

function formatTime(date) {
  return new Date(date).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", hour12: false });
}

export default function UpcomingAppointmentsList({ traderId, onClick, refreshKey }) {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!traderId) return;
    setLoading(true);
    const from = new Date().toISOString();
    agentApi.appointments.list({ traderId, status: "SCHEDULED", from })
      .then((r) => setAppointments((r.appointments ?? []).slice(0, 5)))
      .catch(() => setAppointments([]))
      .finally(() => setLoading(false));
  }, [traderId, refreshKey]);

  if (loading) return <div className="text-sm text-gray-500">Carregando reuniões...</div>;
  if (appointments.length === 0) {
    return <div className="text-sm text-gray-500">Nenhuma reunião agendada.</div>;
  }

  return (
    <div className="space-y-2">
      {appointments.map((appt) => (
        <button
          key={appt.id}
          onClick={() => onClick && onClick(appt.id)}
          className="w-full text-left p-3 bg-white border border-gray-200 rounded hover:border-blue-300 hover:bg-blue-50 transition"
        >
          <div className="flex items-center gap-2">
            <span className="text-blue-600">🔵</span>
            <span className="text-gray-900 font-medium text-sm">
              {formatRelative(appt.slot.startAt)} {formatTime(appt.slot.startAt)}
            </span>
            <span className="text-gray-700 text-sm">·</span>
            <span className="text-gray-900 text-sm">{appt.session?.lead?.name}</span>
          </div>
          {appt.session?.lead?.processId && (
            <div className="text-xs text-gray-500 font-mono mt-1">
              {appt.session.lead.processId}
            </div>
          )}
        </button>
      ))}
    </div>
  );
}
